<template>
  <el-tabs v-model="activeName" class="member-menu" @tab-click="dealClick">
    <el-tab-pane v-for="(menu, index) in menuList" :key="menu.value" :name="menu.name">
      <template v-slot:label>
        <div class="nav-label" @click="select(menu, index)">{{ menu.name }}</div>
      </template>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  name: "member-menu",
  props: {
    menuList: Array,
    active: String
  },
  data() {
    return {
      activeName: "讨论"
    }
  },
  methods: {
    init() {
      this.activeName = this.active
    },
    select(menu) {
      this.$emit("select", menu)
    },
    dealClick(tab) {
      this.select(this.menuList[tab.index])
    }
  }
}
</script>

<style lang="scss" scoped>
.member-menu {
  width: 100%;
  color: $color-font-first;
  ::v-deep {
    .el-tabs__nav {
      margin-left: 20px;
    }
    .el-tabs__item {
      padding: 0 10px;
      font-weight: unset;
      color: #606266;
      &.is-active {
        color: #409eff;
        font-weight: 500;
      }
    }
  }
}
</style>
